var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _path38, _path39, _g2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 233,
    viewBox: "0 0 334 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.371 232.247H34.204C34.204 232.247 57.249 154.015 143.835 108.664C230.421 63.3125 317.973 74.376 317.068 123.385C316.315 164.171 294.166 178.591 289.936 196.378C287.492 206.66 290.899 217.738 298.386 224.221C302.387 227.686 313.081 230.815 321.371 232.247Z",
    fill: "#E9EDF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.06 207.961C322.997 207.961 326.999 203.959 326.999 199.023C326.999 194.086 322.997 190.084 318.06 190.084C313.124 190.084 309.122 194.086 309.122 199.023C309.122 203.959 313.124 207.961 318.06 207.961Z",
    fill: "#E9EDF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.54 177.567C51.9098 171.926 55.7431 158.947 50.102 148.577C44.4609 138.207 31.4815 134.374 21.1118 140.015C10.742 145.656 6.90871 158.636 12.5498 169.005C18.1909 179.375 31.1703 183.208 41.54 177.567Z",
    fill: "#E9EDF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.581 72.4974C155.905 72.4974 160.22 68.1821 160.22 62.859C160.22 57.5358 155.905 53.2205 150.581 53.2205C145.258 53.2205 140.943 57.5358 140.943 62.859C140.943 68.1821 145.258 72.4974 150.581 72.4974Z",
    fill: "#E9EDF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.772 0.2475H147.547C146.511 0.2475 145.671 1.09866 145.671 2.14941V11.2202C145.671 12.2701 146.511 13.1221 147.547 13.1221H156.557L162.718 17.4516V13.1337L167.81 13.0304C168.83 13.0095 169.647 12.1645 169.647 11.1293V2.14941C169.647 1.09943 168.808 0.2475 167.772 0.2475Z",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.111 74.0584C330.111 76.5684 328.105 78.6031 325.63 78.6031C323.155 78.6031 321.148 76.5684 321.148 74.0584C321.148 71.5484 323.155 69.5137 325.63 69.5137C328.105 69.5137 330.111 71.5484 330.111 74.0584Z",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.936 72.8655C53.936 75.3755 51.9293 77.4102 49.4543 77.4102C46.9792 77.4102 44.9725 75.3755 44.9725 72.8655C44.9725 70.3556 46.9792 68.3208 49.4543 68.3208C51.9293 68.3208 53.936 70.3556 53.936 72.8655Z",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7955 13.1648H77.0121",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.62 108.85H300.617",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9014 198.841H27.8747",
    stroke: "#B0CDF2",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M219.011 58.6971C207.305 58.6971 197.783 49.1736 197.783 37.4686C197.783 25.7636 207.305 16.2393 219.011 16.2393C230.717 16.2393 240.239 25.7628 240.239 37.4686C240.239 49.1744 230.717 58.6971 219.011 58.6971ZM219.011 27.25C213.377 27.25 208.793 31.8336 208.793 37.4686C208.793 43.1037 213.377 47.6864 219.011 47.6864C224.645 47.6864 229.23 43.1021 229.23 37.4686C229.23 31.8351 224.645 27.25 219.011 27.25Z",
    fill: "#E5C03B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.083 9.06428H223.636C224.497 9.06428 225.196 9.76322 225.196 10.6245V21.7447H213.522V10.6245C213.522 9.76322 214.221 9.06428 215.082 9.06428H215.083Z",
    fill: "#E5C03B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.523 53.1918H225.197V64.312C225.197 65.1732 224.498 65.8722 223.637 65.8722H215.084C214.223 65.8722 213.523 65.1732 213.523 64.3112V53.191V53.1918Z",
    fill: "#E5C03B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.956 41.7446V33.1918C190.956 32.3306 191.655 31.6309 192.517 31.6309H203.637V43.3048H192.517C191.655 43.3048 190.956 42.6059 190.956 41.7438V41.7446Z",
    fill: "#E5C03B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M235.083 43.3056V31.6317H246.203C247.065 31.6317 247.763 32.3306 247.763 33.1919V41.7446C247.763 42.6059 247.065 43.3048 246.203 43.3048L235.083 43.3056Z",
    fill: "#E5C03B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.251 20.4072L202.299 14.3595C202.908 13.7505 203.896 13.7505 204.505 14.3595L212.368 22.2226L204.114 30.4774L196.25 22.6142C195.641 22.0052 195.642 21.0162 196.251 20.4072Z",
    fill: "#E5C03B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.351 52.7142L234.606 44.4595L242.469 52.3226C243.078 52.9316 243.078 53.9201 242.469 54.5291L236.421 60.5768C235.812 61.1858 234.824 61.1858 234.215 60.5768L226.351 52.7136L226.351 52.7142Z",
    fill: "#E5C03B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.421 14.3595L242.469 20.4073C243.078 21.0163 243.078 22.0047 242.469 22.6137L234.606 30.4769L226.351 22.2222L234.214 14.359C234.823 13.75 235.812 13.75 236.421 14.359L236.421 14.3595Z",
    fill: "#E5C03B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.114 44.4595L212.369 52.7143L204.506 60.5774C203.897 61.1864 202.908 61.1864 202.299 60.5774L196.252 54.5297C195.643 53.9207 195.643 52.9323 196.252 52.3233L204.115 44.4601L204.114 44.4595Z",
    fill: "#E5C03B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.617 232.09H198.253C190.298 232.09 183.839 225.632 183.839 217.676L183.839 51.6976C183.839 43.7428 190.297 37.2846 198.252 37.2846H260.616C268.571 37.2846 275.029 43.7428 275.029 51.6976V217.676C275.029 225.631 268.571 232.089 260.616 232.089L260.617 232.09Z",
    fill: "#2F1D2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184.295 232.09H246.661C254.621 232.09 261.074 225.637 261.074 217.677V51.6976C261.074 43.7375 254.621 37.2846 246.661 37.2846H184.295C176.335 37.2846 169.882 43.7375 169.882 51.6976L169.882 217.677C169.882 225.637 176.335 232.09 184.295 232.09Z",
    fill: "#B0CDF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M184.21 227.723H246.746C252.226 227.723 256.669 223.28 256.669 217.8V52.4858C256.669 47.0057 252.226 42.5631 246.746 42.5631H184.21C178.73 42.5631 174.287 47.0057 174.287 52.4858L174.287 217.8C174.287 223.28 178.73 227.723 184.21 227.723Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.35 47.4371L194.211 47.4371C192.732 47.4371 191.531 46.2365 191.531 44.757V40.3855L236.031 40.3855V44.757C236.031 46.2365 234.83 47.4371 233.35 47.4371Z",
    fill: "#B0CDF2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M200.621 42.5593H224.544",
    stroke: "#312220",
    strokeWidth: 0.622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.678 69.078H187.938C187.323 69.078 186.825 68.5794 186.825 67.9644C186.825 67.3493 187.323 66.8507 187.938 66.8507H238.678C239.293 66.8507 239.792 67.3493 239.792 67.9644C239.792 68.5794 239.293 69.078 238.678 69.078Z",
    fill: "#B0CDF2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M209.261 76.2538H187.939C187.324 76.2538 186.826 75.7553 186.826 75.1402C186.826 74.5251 187.324 74.0265 187.939 74.0265H209.261C209.876 74.0265 210.375 74.5251 210.375 75.1402C210.375 75.7553 209.876 76.2538 209.261 76.2538Z",
    fill: "#B0CDF2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M238.678 195.766H187.938C187.323 195.766 186.825 195.268 186.825 194.653C186.825 194.038 187.323 193.539 187.938 193.539H238.678C239.293 193.539 239.792 194.038 239.792 194.653C239.792 195.268 239.293 195.766 238.678 195.766Z",
    fill: "#B0CDF2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.352 35.6948C111.352 35.6948 109.84 39.3612 113.262 42.4723C118.018 46.7949 113.461 53.4799 113.461 53.4799L96.9941 52.9021L105.413 30.8628L111.353 35.6948H111.352Z",
    fill: "#2F1D2E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.576 26.4866C109.576 26.4866 99.0188 21.7424 92.2553 27.2275L102.489 32.4564L109.575 26.4874L109.576 26.4866Z",
    fill: "#2F1D2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.519 36.4373C88.2247 42.9693 96.209 48.4413 99.8217 48.6044C106.354 48.8987 111.879 44.0356 112.173 37.5036C112.467 30.9715 107.412 25.4227 100.879 25.1431C91.2496 24.7315 88.8126 29.9053 88.5182 36.4373H88.519Z",
    fill: "#2F1D2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.11 42.2308C107.342 44.0232 108.939 45.0118 110.731 44.7796C112.524 44.5474 113.729 42.5173 113.498 40.7249C113.266 38.9325 111.729 38.3345 109.936 38.566C108.144 38.7974 106.879 40.4384 107.111 42.2308H107.11Z",
    fill: "#9F6A49"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3247 43.3654L97.2567 60.5517L104.953 61.0766L105.208 45.96L99.3247 43.3654Z",
    fill: "#AF7E5D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M105.086 53.1863C105.086 53.1863 100.566 51.7349 98.0052 45.5989L105.176 47.8014L105.086 53.1863Z",
    fill: "#925B3E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.562 26.2039C106.562 26.2039 113.726 26.7553 112.77 35.9729C111.814 45.1904 110.984 48.0134 107.124 49.7863C103.656 51.3799 98.9986 49.2117 96.7115 45.171C95.8137 43.5844 95.1916 41.232 95.1318 39.4194L94.6791 36.9809C94.6791 36.9809 92.2592 24.8426 106.563 26.2039H106.562Z",
    fill: "#AF7E5D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9703 32.3057L95.8214 40.8507L91.1727 35.9395L93.838 33.0078L97.9703 32.3057Z",
    fill: "#2F1D2E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.516 41.0472L108.113 42.9491L107.083 43.4461",
    stroke: "black",
    strokeWidth: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.794 38.9869C104.794 38.9869 104.835 37.6837 102.601 37.7746C100.596 37.8561 100.327 38.844 100.327 38.844C100.327 38.844 100.528 40.5882 102.717 40.7195C104.906 40.85 104.794 38.9869 104.794 38.9869Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_1438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 37,
    width: 5,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.794 38.9869C104.794 38.9869 104.835 37.6837 102.601 37.7746C100.596 37.8561 100.327 38.844 100.327 38.844C100.327 38.844 100.528 40.5882 102.717 40.7195C104.906 40.85 104.794 38.9869 104.794 38.9869Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.489 39.0521C101.457 39.977 102.053 40.7474 102.819 40.7715C103.586 40.7964 104.234 40.0656 104.266 39.1406C104.297 38.2157 103.702 37.4453 102.935 37.4212C102.169 37.3964 101.521 38.1264 101.489 39.0521Z",
    fill: "black"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.662 38.7197C103.562 37.5975 101.324 37.4414 100.401 38.8844C100.351 38.983 100.195 38.9007 100.251 38.8036C101.198 37.1036 103.707 37.1347 105.064 38.3516C105.344 38.6196 104.908 39.0218 104.662 38.7197Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.893 39.1756C108.893 39.1756 108.938 37.9082 110.464 38.1171C111.834 38.305 111.962 39.2781 111.962 39.2781C111.962 39.2781 111.741 40.8018 110.233 40.8111C108.726 40.8197 108.893 39.1764 108.893 39.1764V39.1756Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18_1438",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 38,
    width: 4,
    height: 3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.893 39.1756C108.893 39.1756 108.938 37.9082 110.464 38.1171C111.834 38.305 111.962 39.2781 111.962 39.2781C111.962 39.2781 111.741 40.8018 110.233 40.8111C108.726 40.8197 108.893 39.1764 108.893 39.1764V39.1756Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.445 39.4373C111.415 40.3374 110.933 41.0519 110.368 41.0332C109.803 41.0146 109.369 40.2691 109.4 39.369C109.43 38.4689 109.911 37.7544 110.477 37.773C111.041 37.7917 111.475 38.5372 111.445 39.4373Z",
    fill: "black"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.691 38.6009C109.383 37.7878 110.782 37.5269 111.529 38.3788C111.764 38.6335 111.925 38.9325 112.029 39.2571C112.041 39.2936 112.021 39.3325 111.984 39.3441C111.947 39.3558 111.908 39.3348 111.896 39.2983C111.414 37.9532 109.88 37.7901 109.049 38.8665C108.884 39.1329 108.482 38.8362 108.691 38.6009Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M102.35 33.7308C102.35 33.7308 100.918 33.8092 99.9949 34.2146C99.2308 34.5501 99.2789 35.1396 99.9328 35.4044C100.338 35.5683 101.515 35.6405 102.305 35.6009C104.795 35.4766 105.228 34.8429 105.162 34.3731C105.071 33.7122 103.375 33.6384 102.35 33.7308Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M111.306 34.3436C111.306 34.3436 112.403 34.6092 113.095 35.1279C113.668 35.5574 113.606 36.1274 113.094 36.2998C112.776 36.407 111.859 36.3612 111.265 36.1787C109.331 35.5838 109.052 35.051 109.121 34.6006C109.218 33.9669 110.523 34.1176 111.306 34.3436Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.76 44.1723C103.76 44.1723 105.051 45.2921 107.06 45.0949",
    stroke: "black",
    strokeWidth: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3969 39.0816C99.3099 41.013 100.806 42.6501 102.737 42.7371C104.669 42.8241 106.306 41.3283 106.393 39.3969C106.48 37.4647 104.985 35.8284 103.052 35.7414C101.121 35.6545 99.4839 37.1502 99.3969 39.0816Z",
    stroke: "#E5C03B",
    strokeWidth: 0.511,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.284 39.4823C108.207 41.4145 109.507 43.0493 111.187 43.1347C112.867 43.2202 114.292 41.7228 114.37 39.7914C114.448 37.8592 113.148 36.2245 111.468 36.1391C109.787 36.0536 108.362 37.5509 108.284 39.4823Z",
    stroke: "#E5C03B",
    strokeWidth: 0.511,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M108.284 39.4824C108.284 39.4824 107.425 38.8735 106.393 39.3969",
    stroke: "#E5C03B",
    strokeWidth: 0.511,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4024 38.9915L96.4396 38.8735",
    stroke: "#E5C03B",
    strokeWidth: 0.511,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M107.654 26.4307C107.654 26.4307 108.333 32.496 94.1316 33.9995C94.1316 33.9995 90.9413 30.3316 95.2312 27.1312C95.2312 27.1312 100.222 24.7789 105.464 25.3279C106.337 25.4196 107.594 25.9694 107.653 26.4307H107.654Z",
    fill: "#2F1D2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M107.259 26.0308C107.259 26.0308 107.32 26.0649 107.434 26.1434C106.869 26.0781 106.562 26.2039 106.562 26.2039L106.512 27.8496C108.951 28.036 110.688 29.7422 111.705 31.1137C112.048 31.6441 112.404 32.225 112.773 32.8641C112.773 32.8641 114.464 26.5806 107.259 26.0308Z",
    fill: "#2F1D2E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.938 42.0778C95.938 42.0778 102.18 44.6243 100.835 53.2252L86.7383 52.5115C86.7383 52.5115 84.2337 38.5986 90.3557 29.3112L95.938 42.0778Z",
    fill: "#2F1D2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9266 42.2509C96.4598 43.9968 95.0433 44.3944 93.2975 43.9276C91.5517 43.4609 90.6252 41.2887 91.0919 39.5429C91.5587 37.7971 93.1616 37.4073 94.9074 37.874C96.6532 38.3407 97.3925 40.5059 96.9258 42.2517L96.9266 42.2509Z",
    fill: "#AF7E5D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.021 39.9499C93.021 39.9499 94.6573 39.6524 94.992 42.2346",
    stroke: "black",
    strokeWidth: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M113.251 217.108L112.284 203.366L122.53 203.817L123.085 217.25L113.251 217.108Z",
    fill: "#AF7E5D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M123.085 217.25L140.385 226.082C141.654 226.718 142.32 228.142 141.997 229.524L110.574 229.029L113.251 217.108L123.085 217.25Z",
    fill: "#2F1D2E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.574 229.029L110.498 231.425L139.221 231.578C140.498 231.581 141.626 230.746 141.996 229.524L110.574 229.029Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M128.325 219.762L125.821 220.914",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.892 220.914L128.307 222.139",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M133.31 222.47L130.828 223.603",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M110.697 96.8743C110.697 96.8743 118.558 111.643 121.105 144.561C123.845 179.973 125.821 211.339 125.821 211.339H110.855L97.4679 96.8743H110.697Z",
    fill: "#2F1D2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M110.165 204.204H125.229",
    stroke: "#653F67",
    strokeWidth: 0.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9391 217.108L83.2211 203.139L92.9542 203.591L92.2615 217.25L82.9391 217.108Z",
    fill: "#AF7E5D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9391 217.108L73.0048 224.714C71.8779 225.995 71.3778 227.322 71.3778 229.028H93.0692L92.2615 217.249L82.9391 217.108Z",
    fill: "#2F1D2E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3778 231.448H93.0692V229.029H71.3778V231.448Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4988 220.301L79.2836 219.568",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8959 222.025L77.0416 221.223",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.281 223.57L75.1475 222.898",
    stroke: "white",
    strokeWidth: 0.989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M89.701 96.8743C89.701 96.8743 83.7095 102.074 81.469 127.963C79.2285 153.853 80.9394 211.339 80.9394 211.339H94.5261L103.838 96.8743H89.7002H89.701Z",
    fill: "#2F1D2E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M101.225 129.002L102.358 115.079",
    stroke: "#653F67",
    strokeWidth: 0.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9199 204.204H95.107",
    stroke: "#653F67",
    strokeWidth: 0.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M122.877 108.23C122.877 108.23 139.544 104.342 148.509 102.341L149.203 96.9783L121.776 99.3276C119.381 99.4394 117.509 101.434 117.55 103.832C117.595 106.468 120.261 108.557 122.878 108.229L122.877 108.23Z",
    fill: "#AF7E5D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M108.505 80.3007C108.505 80.3007 111.059 93.5807 117.837 105.554C119.098 107.782 121.828 108.823 124.076 107.926C126.083 107.125 127.116 105.003 126.554 102.837L117.963 74.0716L108.505 80.3007Z",
    fill: "#AF7E5D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M113.502 63.9167C113.502 63.9167 119.36 69.7762 123.594 77.5018L111.885 84.9355L113.502 63.9167Z",
    fill: "#E5C03B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M84.709 63.9199C87.751 62.0118 94.1952 58.5093 101.03 58.1303C101.03 58.1303 107.212 58.625 113.502 63.9176C114.361 64.6406 115.635 67.295 115.517 68.8607L110.62 97.3186L89.701 96.8759L82.251 69.6062C82.1516 68.2689 83.5736 64.6336 84.7098 63.9207L84.709 63.9199Z",
    fill: "#E5C03B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8711 59.8139C92.8711 59.8139 97.4872 58.1652 101.03 58.1294C101.03 58.1294 104.034 58.336 107.481 60.0686C107.481 60.0686 108.379 63.276 102.544 63.4072C96.7083 63.5377 92.8711 59.8147 92.8711 59.8147V59.8139Z",
    fill: "#AF7E5D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M112.888 84.1387C112.888 84.1387 114.031 79.0737 113.119 73.1692",
    stroke: "black",
    strokeWidth: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7522 71.7014C80.7522 71.7014 70.2999 81.1511 63.6312 93.4098C62.3909 95.6899 63.1287 98.544 65.3257 99.9271C67.2874 101.162 69.8456 100.857 71.4609 99.194L87.9195 80.9383L80.7522 71.7014Z",
    fill: "#AF7E5D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M84.709 63.9198C84.709 63.9198 78.6212 66.7202 71.7133 76.768L86.3329 86.4243L89.6335 81.8928L84.709 63.9198Z",
    fill: "#E5C03B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7212 85.8915L92.9364 78.5666",
    stroke: "black",
    strokeWidth: 0.366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4722 110.456L86.8222 110.988L70.8233 92.7971C69.3113 90.9363 66.5939 90.6148 64.6897 92.0717C62.5952 93.6739 62.4989 97.0591 64.3161 98.9696C64.3161 98.9696 76.1267 109.335 83.27 115.552L85.2581 118.004L90.4722 110.456Z",
    fill: "#AF7E5D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2581 118.005L92.0767 108.503",
    stroke: "#653F67",
    strokeWidth: 0.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.453 92.6022H256.756V168.208H147.453C143.834 168.208 140.896 165.27 140.896 161.652V99.159C140.896 95.5408 143.834 92.6029 147.453 92.6029V92.6022Z",
    fill: "#5092FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M220.477 107.018H151.651V110.568H220.477V107.018Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M174.617 142.365H151.651V145.916H174.617V142.365Z",
    fill: "#2F1D2E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M201.33 142.365H178.365V145.916H201.33V142.365Z",
    fill: "#2F1D2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M246.709 142.365H205.291V145.916H246.709V142.365Z",
    fill: "#2F1D2E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M192.477 152.343H151.651V155.894H192.477V152.343Z",
    fill: "#2F1D2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M208.559 152.343H195.989V155.894H208.559V152.343Z",
    fill: "#2F1D2E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M170.692 119.407H153.889C152.653 119.407 151.651 120.41 151.651 121.646V131.008C151.651 132.244 152.653 133.246 153.889 133.246H170.692C171.929 133.246 172.931 132.244 172.931 131.008V121.646C172.931 120.41 171.929 119.407 170.692 119.407Z",
    fill: "#B0CDF2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M162.337 129.992H149.253V122.661H162.337C164.358 122.661 166.002 124.306 166.002 126.327C166.002 128.349 164.358 129.993 162.337 129.993V129.992ZM150.139 129.107H162.337C163.869 129.107 165.116 127.859 165.116 126.327C165.116 124.795 163.87 123.548 162.337 123.548H150.139V129.107Z",
    fill: "#5092FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M174.594 125.884H165.558V126.77H174.594V125.884Z",
    fill: "#5092FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M333.463 232.091H0",
    stroke: "#2F1D2E",
    strokeWidth: 0.495,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0301 44.4852H45.1037C44.2269 44.4852 43.5147 43.7731 43.5147 42.8963V33.8978C43.5147 33.021 44.2269 32.3088 45.1037 32.3088H64.4412C65.3179 32.3088 66.0301 33.021 66.0301 33.8978V44.4852Z",
    fill: "#E07C6B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0293 41.9659L66.0456 47.3463L61.452 41.9807L66.0293 41.9659Z",
    fill: "#E07C6B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7825 38.2584C51.7841 38.771 51.3701 39.1872 50.8584 39.1888C50.3466 39.1903 49.9295 38.7764 49.928 38.2646C49.9264 37.7529 50.3404 37.3358 50.8521 37.3343C51.3639 37.3327 51.781 37.7466 51.7825 38.2592V38.2584Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7611 38.246C55.7626 38.7578 55.3487 39.1748 54.8369 39.1764C54.3251 39.1779 53.9081 38.764 53.9066 38.2522C53.905 37.7397 54.3189 37.3234 54.8307 37.3218C55.3425 37.3203 55.7595 37.7342 55.7611 38.246Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7388 38.2336C59.7404 38.7461 59.3264 39.1624 58.8147 39.1639C58.3029 39.1655 57.8858 38.7516 57.8843 38.2398C57.8827 37.728 58.2967 37.311 58.8084 37.3094C59.321 37.3079 59.7373 37.7218 59.7388 38.2336Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M321.398 35.7196C322.938 26.1633 316.439 17.1682 306.883 15.6284C297.326 14.0887 288.331 20.5874 286.791 30.1437C285.252 39.7001 291.75 48.6952 301.307 50.2349C310.863 51.7747 319.858 45.276 321.398 35.7196Z",
    fill: "#5092FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M306.014 32.3733L303.021 31.2294C302.492 31.0236 302.141 30.525 302.141 29.9674C302.141 29.6156 302.287 29.263 302.522 29.0285C302.786 28.7644 303.109 28.6472 303.49 28.6472H304.664C305.28 28.6472 305.779 29.0285 305.955 29.6156C306.131 30.2609 306.806 30.6127 307.451 30.4372C308.096 30.2609 308.478 29.5861 308.273 28.9407C307.891 27.5319 306.688 26.5053 305.28 26.2707V25.2728C305.28 24.5979 304.752 24.0698 304.077 24.0698C303.402 24.0698 302.874 24.5979 302.874 25.2728V26.2995C302.111 26.4167 301.407 26.7981 300.849 27.3261C300.145 28.0305 299.763 28.9982 299.763 29.9666C299.763 31.4926 300.732 32.9006 302.169 33.4582L305.162 34.6022C305.691 34.808 306.042 35.3065 306.042 35.8641C306.042 36.598 305.426 37.2139 304.693 37.2139H303.519C302.903 37.2139 302.404 36.8326 302.228 36.2455C302.052 35.6001 301.377 35.2188 300.732 35.4238C300.087 35.6001 299.705 36.275 299.91 36.9203C300.292 38.3291 301.495 39.3558 302.874 39.5903V40.5875C302.874 41.2623 303.402 41.7904 304.077 41.7904C304.752 41.7904 305.28 41.2623 305.28 40.5875V39.5903C307.04 39.2967 308.419 37.7715 308.419 35.8937C308.419 34.3389 307.48 32.9596 306.013 32.3725L306.014 32.3733Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M278.352 73.8184H243.098C240.513 73.8184 238.418 75.914 238.418 78.499V113.753C238.418 116.338 240.513 118.434 243.098 118.434H278.352C280.937 118.434 283.033 116.338 283.033 113.753V78.499C283.033 75.914 280.937 73.8184 278.352 73.8184Z",
    fill: "#E5C03B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M266.578 85.3463C264.037 84.5022 262.278 83.1804 261.391 82.396C261.009 82.0582 260.443 82.0582 260.061 82.396C259.174 83.1796 257.414 84.5022 254.874 85.3463C252.547 86.1191 250.105 86.3 248.793 86.3373C248.25 86.3528 247.825 86.804 247.843 87.3469C247.948 90.3958 248.555 99.5776 252.065 103.702C256.05 108.384 260.727 109.21 260.727 109.21C260.727 109.21 265.403 108.385 269.388 103.702C272.899 99.5776 273.505 90.395 273.61 87.3469C273.628 86.804 273.203 86.3536 272.66 86.3381C271.348 86.3008 268.906 86.1198 266.578 85.3463Z",
    fill: "#5092FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M255.517 96.1994L259.204 99.9675L266.413 91.5297",
    stroke: "white",
    strokeWidth: 2.384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M314.273 163.531C322.985 163.531 330.048 156.468 330.048 147.756C330.048 139.043 322.985 131.981 314.273 131.981C305.56 131.981 298.498 139.043 298.498 147.756C298.498 156.468 305.56 163.531 314.273 163.531Z",
    fill: "#E07C6B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M319.637 143.697C318.344 142.431 316.274 142.453 315.01 143.746L314.176 144.597L313.318 143.752C312.032 142.483 309.96 142.501 308.691 143.787C307.423 145.075 307.439 147.147 308.727 148.415L311.91 151.55C311.917 151.557 311.921 151.565 311.928 151.571C312.436 152.069 313.064 152.367 313.718 152.468C314.725 152.622 315.789 152.306 316.555 151.523L319.687 148.326C320.951 147.034 320.929 144.962 319.638 143.698L319.637 143.697Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1168 121.72H62.6511C64.9211 121.72 66.764 123.563 66.764 125.833V145.463C66.764 147.733 64.9211 149.575 62.6511 149.575H39.1168C36.8468 149.575 35.0047 147.733 35.0047 145.463V125.834C35.0047 123.564 36.8476 121.722 39.1168 121.722V121.72Z",
    fill: "#5092FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6782 134.509L55.7176 134.341C55.605 133.922 55.4388 133.52 55.2221 133.144L55.782 132.346C55.9878 132.052 55.9529 131.654 55.6997 131.401L55.1242 130.825C54.8672 130.577 54.4688 130.548 54.1791 130.758L53.3808 131.317C53.0057 131.101 52.6034 130.934 52.184 130.822L52.0186 129.84C51.9588 129.491 51.659 129.234 51.3057 129.228H50.4763C50.1167 129.227 49.8092 129.485 49.7478 129.84L49.5793 130.797C49.1607 130.91 48.7584 131.076 48.3825 131.293L47.5873 130.757C47.2937 130.551 46.8953 130.586 46.6422 130.839L46.0667 131.415C45.8127 131.668 45.7786 132.067 45.9844 132.36L46.5443 133.159C46.3276 133.534 46.1607 133.936 46.0488 134.356L45.0913 134.524C44.7372 134.585 44.4785 134.893 44.4793 135.253V136.066C44.4793 136.426 44.7372 136.734 45.0913 136.795L46.0488 136.963C46.1614 137.382 46.3276 137.784 46.5443 138.16L45.9844 138.958C45.7786 139.252 45.8135 139.65 46.0667 139.904L46.6422 140.48C46.8953 140.734 47.2945 140.769 47.5873 140.562L48.3856 140.002C48.7615 140.219 49.163 140.386 49.5824 140.498L49.7509 141.455C49.8123 141.809 50.1198 142.068 50.4794 142.067H51.3057C51.6652 142.068 51.9728 141.809 52.0341 141.455L52.2027 140.498C52.6212 140.385 53.0235 140.219 53.3994 140.002L54.1799 140.55C54.4735 140.756 54.8719 140.721 55.125 140.467L55.7005 139.892C55.9544 139.639 55.9886 139.24 55.7828 138.947L55.2229 138.142C55.4395 137.767 55.6057 137.365 55.7183 136.946L56.679 136.777C57.0331 136.716 57.2918 136.408 57.291 136.049V135.235C57.291 134.877 57.0316 134.571 56.6782 134.509ZM50.8832 137.838C49.6701 137.838 48.6862 136.854 48.6862 135.641C48.6862 134.428 49.6701 133.444 50.8832 133.444C52.0963 133.444 53.0802 134.428 53.0802 135.641V135.653C53.0732 136.862 52.0916 137.838 50.8832 137.838Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.6859f1d8f82e5c05d6ed6fca445f7c0e.svg";
export { ForwardRef as ReactComponent };